"use client";

import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./styles.module.scss";
import ClickToScroll from "@/components/sections/NewLists/ClickToScroll";
import VideoTestimonialWithDescCard from "@molecules/VideoTestimonialWithDescCard/VideoTestimonialWithDescCard";

export default function VideoTestimonialWithDesc({
  isDesktop,
  testimonials,
  showRating = true,
  isOverflowCarousel = false,
  sectionHeading=""
}) {
  if (isOverflowCarousel && isDesktop) {
    return (
      <div className={styles.carouselRoot} id="videoTestimonials">
        <ClickToScroll id="videoTestimonials" />
        {testimonials?.map((d, index) => (
          <VideoTestimonialWithDescCard
            {...d?.attributes}
            showRating={showRating}
            key={index}
            isBigImage={isOverflowCarousel}
            sectionHeading={sectionHeading}
          />
        ))}
      </div>
    );
  }
  return (
    <div className="Carousel">
      <Swiper
        autoplay={{
          delay: 6000,
        }}
        modules={[Pagination, Autoplay]}
        spaceBetween={16}
        slidesPerView={1}
        pagination={{ clickable: true }}
        className="Carousel__blueBullet Carousel__hAuto"
        breakpoints={{
          1199: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 40,
          },
        }}
      >
        {testimonials?.map((d, index) => (
          <SwiperSlide key={index}>
            <VideoTestimonialWithDescCard
              {...d?.attributes}
              showRating={showRating}
              sectionHeading={sectionHeading}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
